import React from 'react';
import { Card } from '../components/ui/card';
import { Search, FileText, MessageSquare, Shield, Lock, RefreshCw, CheckCircle, Zap, Layers, Scale, AlertTriangle, FileSignature } from 'lucide-react';
import { mockData } from '../data/mockData';

const iconMap = {
  Search: Search,
  FileText: FileText,
  MessageSquare: MessageSquare,
  Shield: Shield,
  Lock: Lock,
  RefreshCw: RefreshCw,
  CheckCircle: CheckCircle,
  Zap: Zap,
  Layers: Layers,
  Scale: Scale,
  AlertTriangle: AlertTriangle,
  FileSignature: FileSignature
};

const ServicesSection = () => {
  return (
    <section id="services" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">
              Comprehensive Trademark Registration Services
            </h2>
            <div className="w-24 h-1 bg-amber-500 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              From initial search to final registration, we provide complete trademark services to protect your brand identity in the United States.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
            {mockData.services.map((service, index) => {
              const IconComponent = iconMap[service.icon];
              return (
                <Card
                  key={index}
                  className="p-6 hover:shadow-xl transition-all duration-300 border-t-4 border-amber-500 group hover:-translate-y-1"
                >
                  <div className="w-14 h-14 bg-blue-100 rounded-lg flex items-center justify-center mb-4 group-hover:bg-amber-500 transition-colors">
                    <IconComponent className="text-blue-900 group-hover:text-white transition-colors" size={28} />
                  </div>
                  <h3 className="text-xl font-bold text-blue-900 mb-3">
                    {service.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed mb-3">
                    {service.description}
                  </p>
                  {service.details && (
                    <p className="text-sm text-gray-500 leading-relaxed border-t pt-3 mt-3">
                      {service.details}
                    </p>
                  )}
                </Card>
              );
            })}
          </div>

          <div className="mt-12 bg-gradient-to-r from-blue-900 to-blue-800 rounded-2xl p-8 md:p-10 text-white">
            <div className="max-w-4xl mx-auto text-center">
              <h3 className="text-2xl md:text-3xl font-bold mb-4">
                Why Trademark Registration Matters
              </h3>
              <p className="text-lg text-blue-100 mb-6">
                Federal registration provides exclusive nationwide rights, legal protection against infringement, and builds valuable brand equity.
              </p>
              <div className="grid md:grid-cols-3 gap-6">
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-xl font-bold text-amber-400 mb-2">Exclusive Rights</div>
                  <p className="text-sm text-blue-100">Nationwide brand protection</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-xl font-bold text-amber-400 mb-2">Legal Power</div>
                  <p className="text-sm text-blue-100">Sue infringers in federal court</p>
                </div>
                <div className="bg-white/10 backdrop-blur-sm rounded-lg p-4">
                  <div className="text-xl font-bold text-amber-400 mb-2">Brand Value</div>
                  <p className="text-sm text-blue-100">Increase business worth</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
